import { render, staticRenderFns } from "./ProtomeAnalysis.vue?vue&type=template&id=7ecd3ba2&scoped=true"
import script from "./ProtomeAnalysis.vue?vue&type=script&lang=js"
export * from "./ProtomeAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ProtomeAnalysis.vue?vue&type=style&index=0&id=7ecd3ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecd3ba2",
  null
  
)

export default component.exports